class NBPersonalize extends HTMLElement {
  constructor() {
    super();

    const form = this.querySelector('form');

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const modalDialog = document.querySelector(`#PopupModal-${this.dataset.block}`);
      modalDialog.hide();

      console.log(this.dataset.block);

      const personalizationText = document.querySelector(`#personalization-${this.dataset.block}`);

      if (personalizationText.value.length > 0) {
        const modalOpener = document.querySelector(`#PopupOpener-${this.dataset.block}`);
        modalOpener.dataset.hasPersonalization = 'true';
      }
    });

    const personalizeText = this.querySelector('[js-personalize-text]');
    const personalizeTextContainer = this.querySelector('[js-personalize-text-container]');
    personalizeText.addEventListener('input', () => {
      personalizeTextContainer.innerHTML = personalizeText.value;
    });

    const fontRadios = this.querySelectorAll('[js-personalize-font]');
    fontRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.dataset.font = radio.value;
      });
    });

    const colorRadios = this.querySelectorAll('[js-personalize-color]');
    colorRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.dataset.color = radio.value;
      });
    });
  }
}
if (!customElements.get('nb-personalize')) {
  customElements.define('nb-personalize', NBPersonalize);
}
